// extracted by mini-css-extract-plugin
module.exports = {"remindPasswordForm":"KIhIh7","actions":"_1wq_su","linkBack":"_2Eq1m7","field":"_28A6iz","resetPassword":"_3ManVq"};